import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { Menu, Icon, Dropdown, Tooltip } from "antd";

import MessageBox from "../MessageBox";

import "./MessageBoxWrapper.scss";

import { ReactComponent as CloseSvg } from "../../assets/icon/ic_close_24dp.svg";

function MenuChatSwapper({
  hiddenChats,
  openMessageBox,
  closeChat,
  getChatTitle,
  notifications,
  flags,
}) {
  return (
    hiddenChats.length && (
      <Menu className="menu-chat-swap">
        {hiddenChats.map((chat, index) => {
          return (
            <Menu.Item
              key={index}
              className={`${notifications[chat.id] ? "unread" : ""}`}
            >
              <div
                className="menu-swap-item"
                onClick={() => openMessageBox(chat)}
              >
                <div className="message-props">
                  <span
                    className={`message-title ${
                      notifications[chat.id] ? "unread" : ""
                    }`}
                  >
                    {getChatTitle(chat)}
                  </span>
                </div>

                <Tooltip
                  title={<FormattedMessage id="tooltip.close" />}
                  overlayClassName="social-tooltip"
                >
                  <Icon
                    className="action-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      closeChat(chat.id);
                    }}
                    component={CloseSvg}
                  />
                </Tooltip>
              </div>
            </Menu.Item>
          );
        })}
      </Menu>
    )
  );
}

function MessagesDropdown({
  hiddenChats,
  openMessageBox,
  closeChat,
  getChatTitle,
  notifications,
  hiddenHasUnreadMessages,
  flags,
}) {
  return (
    !!hiddenChats.length && (
      <Dropdown
        placement="topRight"
        overlay={
          <MenuChatSwapper
            hiddenChats={hiddenChats}
            openMessageBox={openMessageBox}
            closeChat={closeChat}
            getChatTitle={getChatTitle}
            notifications={notifications}
            flags={flags}
          />
        }
      >
        <div
          className={`hidden-conversations-container ${
            hiddenHasUnreadMessages ? "notify" : ""
          }`}
        >
          <span className="hidden-chats-button">+{hiddenChats.length}</span>
        </div>
      </Dropdown>
    )
  );
}

function MessageBoxes(props) {
  const {
    flags,
    chats,
    templateSettings,
    messageVisibilityOptions,
    closeChat,
    setChatAsRead,
    onCardClick,
    getChatNewMessages,
    dismissNotification,
    handshakeNewChatCreated,
    connection,
    updateChatState,
    getChatList,
    notifications,
    profiles,
    mentions,
  } = props;

  return chats.map((chat) => (
    <MessageBox
      id={chat.id}
      chat={chat}
      templateSettings={templateSettings}
      messageVisibilityOptions={messageVisibilityOptions}
      key={chat.id}
      onCardClick={onCardClick}
      closeChat={closeChat}
      wsConnection={connection}
      newMessage={getChatNewMessages(chat.id)}
      notifications={notifications}
      dismissNotification={dismissNotification}
      handshakeNewChatCreated={handshakeNewChatCreated}
      setChatAsRead={setChatAsRead}
      updateChatState={updateChatState}
      getChatList={getChatList}
      flags={flags}
      profiles={profiles}
      mentions={mentions}
    />
  ));
}

class MessageBoxWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getChatTitle(item) {
    const { flags } = this.props;
    const { formatMessage } = this.props.intl;
    const currentFlag = flags.find(
      (elem) => elem.id === (item.flags && item.flags[0] && item.flags[0].id)
    );
    const archivedPrefix =
      (currentFlag && currentFlag.alternativeArchivedPrefix) ||
      "chat.archivedPrefix";

    if (item.newChat) {
      return formatMessage({ id: "chat.newChat" });
    }

    if (item.description) {
      return item.archived
        ? `${formatMessage({ id: archivedPrefix })} ${item.description}`
        : item.description;
    }

    const hasOtherRecipients = item.recipients.length - 1 > 0;

    return formatMessage(
      {
        id: hasOtherRecipients
          ? "chat.noDescriptionTitle"
          : "chat.noDescriptionTitleNoOthers",
      },
      {
        name: item.createdBy.username,
        archived: item.archived ? formatMessage({ id: archivedPrefix }) : "",
        ...(hasOtherRecipients && { number: item.recipients.length - 1 }),
      }
    );
  }

  hiddenHasUnreadMessages() {
    for (let i in this.props.hiddenChats) {
      let hidden = this.props.hiddenChats[i];
      if (this.props.notifications[hidden.id]) return true;
    }
    return false;
  }

  render() {
    const {
      hiddenChats,
      openMessageBox,
      closeChat,
      notifications,
      flags,
      chats,
      templateSettings,
      messageVisibilityOptions,
      onCardClick,
      getChatNewMessages,
      dismissNotification,
      handshakeNewChatCreated,
      setChatAsRead,
      wsConnection,
      updateChatState,
      getChatList,
      profiles,
      mentions,
    } = this.props;

    return (
      <div className="message-boxes-wrapper">
        <MessagesDropdown
          hiddenChats={hiddenChats}
          openMessageBox={openMessageBox}
          closeChat={closeChat}
          getChatTitle={this.getChatTitle.bind(this)}
          notifications={notifications}
          hiddenHasUnreadMessages={this.hiddenHasUnreadMessages()}
          flags={flags}
        />

        <MessageBoxes
          chats={chats}
          templateSettings={templateSettings}
          messageVisibilityOptions={messageVisibilityOptions}
          closeChat={closeChat}
          onCardClick={onCardClick}
          getChatNewMessages={getChatNewMessages}
          notifications={notifications}
          dismissNotification={dismissNotification}
          handshakeNewChatCreated={handshakeNewChatCreated}
          setChatAsRead={setChatAsRead}
          connection={wsConnection}
          updateChatState={updateChatState}
          getChatList={getChatList}
          flags={flags}
          profiles={profiles}
          mentions={mentions}
        />
      </div>
    );
  }
}

export default injectIntl(MessageBoxWrapper);
